/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { LuUserSquare2 } from "react-icons/lu";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { RiProfileLine } from "react-icons/ri";
import { TbPencil, TbUserEdit } from "react-icons/tb";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Col,
  Dialog,
  FabButton,
  InputField,
  Row,
  Typography,
} from "../../ppui";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import { Snackbar } from "../../ppui/snackbar";
import { ORGANIZATION_CATEGORY, ORGANIZATION_FORM_FIELDS } from "../organization/profile/profile-contants";
import useOrganisationService from "../organization/profile/use-profile-service";
import {
  ContentBody,
  ContentForm,
  ContentHeading,
  ContentLayout,
  ContentMenu,
  ContentWrapper,
  HeaderBorder,
  OrganizationSticky,
  PhotoUpload,
  ProfileHeaderIocn,
} from "../style";
import useOrgDetailsService from "./use-orgdetails-service";

function OrganizationDetails() {
  const {
    // orgProfile,
    handleClick,
    // orgAcName,
    // handleChange,
    // handleAddRow,
    // handleDeleteRow,
    // fileInputRef,
    // setPreviewURL,
    // setSelectedFile,
    // previewURL,
    // stateList,
    // setOrgProfile,
    // createUpdateLoading,
    getInputFieldProps,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    
  } = useOrganisationService();
  const { 
    // fetchOrgDetailsData,
    orgDetails,
    // allState,
    handleClickOpen,
    handleCloseBasicInfo,
    fetchOrgDetailsData,
    // handleClick,
    open } = useOrgDetailsService()
  // const [open, setOpen] = React.useState(false);
  // const handleClickOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <RiProfileLine />,
      primaryText: "Personal Info",
      path: "/organization-details",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "Ownership Info",
      path: "/organization-details/ownership-info",
    },
    {
      icon: <HiOutlineOfficeBuilding />,
      primaryText: "Branch Info",
      path: "/organization-details/branch-info",
    },
    {
      icon: <MdOutlineDocumentScanner />,
      primaryText: "Allowance Info",
      path: "/organization-details/allowance-info",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "Leave Info",
      path: "/organization-details/leave-details",
    },

    {
      icon: <HiOutlineOfficeBuilding />,
      primaryText: "Holiday Info",
      path: "/organization-details/holiday-info",
    },
  ];
  function getOrganizationCategoryName(id) {
    const category = ORGANIZATION_CATEGORY.find(item => item.id === id);
    return category ? category.name : 'N/A';
  }
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Organization Details
          </Typography>
        </ContentHeading>
        {orgDetails?.org_name && <OrganizationSticky>
          <ContentBody Padding>

            <ProfileHeaderIocn>
              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={handleClickOpen}
                variant="filled"
                shape="box"
              />
            </ProfileHeaderIocn>

            <Row alignItem="center">
              <Col sm={12}>
                <Row alignItem="center">
                  <Col sm={"auto"}>
                    <PhotoUpload>
                      <TbUserEdit />
                    </PhotoUpload>
                  </Col>

                  <Col sm={3}>
                    <HeaderBorder>
                      <Typography variant="h6" mb={10}>
                        {orgDetails?.org_name || 'N/A'}
                      </Typography>
                      <Typography variant="body2">{getOrganizationCategoryName(orgDetails?.registration_type) || 'N/A'}</Typography>
                    </HeaderBorder>
                  </Col>

                  <Col sm={2}>
                    <HeaderBorder>
                      <Typography variant="body1" mb={"0"}>
                        Domain Name
                      </Typography>
                      <Typography variant="body2" mb={"0"}>
                        {orgDetails?.domain_name || 'N/A'}
                      </Typography>
                    </HeaderBorder>
                  </Col>

                  <Col sm={2}>
                    <HeaderBorder>
                      <Typography variant="body1" mb={"0"}>
                        Contact Number
                      </Typography>
                      <Typography variant="body2" mb={"0"}>
                        {orgDetails?.phone || 'N/A'}
                      </Typography>
                      <Typography variant="body2" mb={"0"}>
                        {orgDetails?.landline || 'N/A'}
                      </Typography>
                    </HeaderBorder>
                  </Col>

                  <Col sm={3}>
                    <Typography variant="body1" mb={"0"}>
                      Email ID
                    </Typography>
                    <Typography variant="body2" mb={"0"}>
                      {orgDetails?.email || 'N/A'}
                    </Typography>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ContentBody>
        </OrganizationSticky>}
        <ContentWrapper>
          <ContentMenu>
            <List
              size={"md"}
              color={"default"}
              activeColor={"success"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => navigate(item.path)}
                  className={location.pathname === item.path ? "active" : ""}
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>
          </ContentMenu>
          <ContentForm>
            <Outlet />
          </ContentForm>
        </ContentWrapper>
      </ContentLayout>

      {/* Profile-Header-Modal */}
      <Dialog
        title="Basic Information"
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={open}
        buttonName={"Update"}
        onClose={handleCloseBasicInfo}
        onSubmit={()=>handleClick(handleCloseBasicInfo,fetchOrgDetailsData)}
        separator
      >
        <Row rowGap>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.org_name.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.domain_name.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.phone.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landline.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.email.name)}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Profile-Header-Modal */}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={
          closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default OrganizationDetails;
